<template>
  <nav class="no-selection flex-col flex">
    <SMIcon
      v-if="!app.isMobileDevice"
      title="Zoom In"
      :class="[baseIconClasses, { active: activeZoom === ZOOM.IN }]"
      icon="add_circle_outline"
      @click.prevent.stop="zoomManager.zoomIn(ZOOM.STEP)"
    />

    <SMIcon
      v-if="!app.isMobileDevice"
      title="Zoom Out"
      :class="[baseIconClasses, { active: activeZoom === ZOOM.OUT }]"
      icon="remove_circle_outline"
      @click.prevent.stop="zoomManager.zoomOut(ZOOM.STEP)"
    />

    <SMIcon
      v-if="RENDERER_MODE && !isInFullScreen && $app.props.isShowFullscreen && !app.isMobileDevice"
      title="Full Screen"
      :class="[baseIconClasses]"
      icon="fullscreen"
      @click.prevent.stop="requestFullScreen"
    />

    <SMIcon
      v-if="RENDERER_MODE && isInFullScreen && $app.props.isShowFullscreen && !app.isMobileDevice"
      title="Full Screen Exit"
      :class="[baseIconClasses]"
      icon="fullscreen_exit"
      @click.prevent.stop="requestFullScreen"
    />
  </nav>
</template>

<script setup>
import { RENDERER_MODE, ZOOM } from '@/constants';
import Application from '@/core/application';
import { onUnmounted, ref } from 'vue';
import SMIcon from '../ui/SMIcon.vue';

const app = Application.instance;
const zoomManager = app.zoomManager;

// TODO: implement active zoom (animation) again
const activeZoom = ref(null);

const isInFullScreen = ref(false);

const baseIconClasses = 'text-2xl cursor-pointer';

const onFullScreenChange = () => {
  isInFullScreen.value = !!document.body.fullscreenElement;
};

const requestFullScreen = () => {
  if (isInFullScreen.value) {
    document.exitFullscreen();
    return;
  }

  document.documentElement.requestFullscreen();
};

document.addEventListener('fullscreenchange', onFullScreenChange);

onUnmounted(() => {
  document.removeEventListener('fullscreenchange', onFullScreenChange);
});
</script>
